import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcSendIcon } from '@gem/icons';
import date from '@gem/services/date-service';
import { FAB } from '@gem/ui-kit';

import { ScheduleOnboarding } from './ScheduleOnboarding/ScheduleOnboarding';
import { useSubmitButtonPresenter } from './SubmitButton.presenter';
import styles from './SubmitButton.styles.m.css';
import { SubmitButtonMenu } from './SubmitButtonMenu/SubmitButtonMenu';

interface ISubmitButtonProps {
  isSlowMode: boolean;
  remainingSecond: number;
}

export const SubmitButton: FC<ISubmitButtonProps> = observer((props) => {
  const { isSlowMode, remainingSecond } = props;
  const { presenter, submitButtonRef } = useSubmitButtonPresenter();

  return (
    <div>
      {isSlowMode ? (
        <button
          className={styles.timer}
          onContextMenu={presenter.onToggleMenu}
          ref={submitButtonRef}
        >
          {date.secondsToString(remainingSecond)}
        </button>
      ) : (
        <FAB
          size={'30'}
          onClick={presenter.onSubmit}
          Icon={IcSendIcon}
          theme={'17'}
          isDisabled={presenter.isDisabled}
          onContextMenu={presenter.onToggleMenu}
          setRef={submitButtonRef}
          dataTest="send-message-button"
        />
      )}

      {presenter.isShowMenu && (
        <SubmitButtonMenu
          reference={submitButtonRef}
          onClose={presenter.onCloseMenu}
          onSetDisabled={presenter.onSetSubmitDisabled}
        />
      )}

      {presenter.isShowOnboarding && <ScheduleOnboarding reference={submitButtonRef} />}
    </div>
  );
});
